import { DOMAINS } from './domains'
import { LEVELS } from './levels'
import type { Answers, DomainScore, Grade, JudgeResult } from './types'

export const QUESTIONS_PER_DOMAIN = 5
export const DOMAIN_COUNT = DOMAINS.length

// 設問番号のキー（qid(0,0) → "q1"）。カテゴリ×設問インデックスから一意に決まる。
export function questionId(domainIndex: number, questionIndex: number): string {
  return `q${domainIndex * QUESTIONS_PER_DOMAIN + questionIndex + 1}`
}

// カテゴリ得点：5問 × 1〜5点 = 5〜25点
export function domainScore(answers: Answers, domainIndex: number): number {
  let score = 0
  for (let i = 0; i < QUESTIONS_PER_DOMAIN; i++) {
    score += answers[questionId(domainIndex, i)] || 0
  }
  return score
}

// グレード：A≥21 / B≥17 / C≥13 / D≥9 / それ以外E
export function grade(score: number): Grade {
  if (score >= 21) return 'A'
  if (score >= 17) return 'B'
  if (score >= 13) return 'C'
  if (score >= 9) return 'D'
  return 'E'
}

export function findLevel(normalizedScore: number) {
  return LEVELS.find((l) => normalizedScore >= l.min && normalizedScore <= l.max) ?? LEVELS[0]
}

export function judge(answers: Answers): JudgeResult {
  const scores = DOMAINS.map((_, i) => domainScore(answers, i))
  const total = scores.reduce((a, b) => a + b, 0)
  const normalized = Math.round((total / (DOMAIN_COUNT * 25)) * 100)
  const level = findLevel(normalized)

  const domainScores: DomainScore[] = DOMAINS.map((d, i) => ({
    name: d.name,
    score: scores[i],
    grade: grade(scores[i]),
  }))

  // 優先領域：スコアの低い順に3領域
  const lowestThree = scores
    .map((score, i) => ({ i, score }))
    .sort((a, b) => a.score - b.score)
    .slice(0, 3)

  const priorityDomains = lowestThree.map((p, rank) => ({
    rank: rank + 1,
    name: DOMAINS[p.i].name,
    desc: DOMAINS[p.i].priorityDesc,
    actions: DOMAINS[p.i].priorityActions,
  }))

  // 対応する研修テーマ：優先3領域それぞれの研修をグループ表示
  const trainings = lowestThree.map((p) => ({
    name: DOMAINS[p.i].name,
    items: DOMAINS[p.i].training,
  }))

  return {
    totalScore: normalized,
    phase: level.phase,
    phaseName: level.name,
    phaseCopy: level.copy,
    phaseColor: level.color,
    phaseDesc: level.desc,
    domainScores,
    priorityDomains,
    trainings,
  }
}
